import React from "react";
import { Link } from "react-router-dom";

import workPassportFinalDemonstrationOneSiteScopeDesktop from "../../images/work-passport-final-demonstration-one-site-scope-desktop.svg";
import workPassportFinalDemonstrationOneSiteScopeMobile from "../../images/work-passport-final-demonstration-one-site-scope-mobile.svg";

import "./WorkPassportFinalDemonstrationCTA.css";

export default function WorkPassportFinalDemonstrationCTA() {
  return (
    <section
      className="work-passport-final-demonstration"
      id="work-passport-final-demonstration"
      aria-labelledby="work-passport-final-demonstration-title"
    >
      <div className="work-passport-final-demonstration__shell">
        <div className="work-passport-final-demonstration__copy">
          <p className="work-passport-final-demonstration__kicker">
            Work Passport by AndUs
          </p>
          <h2 id="work-passport-final-demonstration-title">
            Know who is ready <em>before work begins.</em>
          </h2>
          <p>
            Let us map one site, one workforce segment and one role family into
            a practical demonstration using your operating reality.
          </p>
          <Link
            className="work-passport-final-demonstration__action"
            to="/contactAndUs"
          >
            Request a Work Passport demonstration
            <span aria-hidden="true">→</span>
          </Link>
          <small>A practical first scope. No generic presentation.</small>
        </div>

        <picture className="work-passport-final-demonstration__scope">
          <source
            media="(max-width: 620px)"
            srcSet={workPassportFinalDemonstrationOneSiteScopeMobile}
          />
          <img
            src={workPassportFinalDemonstrationOneSiteScopeDesktop}
            alt="Demonstration scope of one site, one workforce segment and one role family"
            loading="lazy"
          />
        </picture>
      </div>
    </section>
  );
}
